import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FormWrapperLogin } from "src/components/ui";
import { UserContext } from "src/contexts/UserContext";
import Cookies from "js-cookie";
import useUserCheck from "src/layouts/useUserCheck";
import LoginForm from "./LoginForm";
import useSecureLogin from "src/services/login/useSecureLogin";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/system";

const LoginPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { loginStatus } = useUserCheck();
  const { fetchWSO2Token } = useSecureLogin();
  const { wSO2Token } = useContext(UserContext);

  // if there is userInfo >>> we're logged in >>> redirect to home page
  useEffect(() => {
    loginStatus();
    if (
      Cookies.get("tdlvjnhdj") === "oizxhonc9uwhfijhbiuwefADHBFIUdhcijbcdw" ||
      Cookies.get("tdlvjnhdj") === "oijusahdfijuhaswfiuhwfouweqrufojhwdfiu"
    ) {
      navigate("/");
    } else {
      if (!wSO2Token || wSO2Token?.access_token?.length < 10) fetchWSO2Token();
      else {
        Cookies.set("nmzbxcbashsaoisd", wSO2Token?.access_token);
      }
    }
    if (typeof window !== "undefined") {
      const isMobile = window.innerWidth <= 767;
      if (isMobile) {
        const mobileBase = process.env.REACT_APP_MOBILE_URL;
        const restOfUrl = window.location.href.replace(window.location.origin, "");
        const newUrl = `${mobileBase}${restOfUrl}`;
        window.location.href = newUrl;
      }
    }
  }, []);

  if (wSO2Token?.access_token?.length < 10) fetchWSO2Token();
  else {
    Cookies.set("nmzbxcbashsaoisd", wSO2Token?.access_token);
  }
  return (
    <FormWrapperLogin>
      {wSO2Token?.access_token?.length > 10 ? (
        <LoginForm />
      ) : (
        wSO2Token === "" && (
          <Stack sx={{ background: alpha(theme.palette.error.main, 0.1), borderRadius: 1.5, px: 2, py: 1 }}>
            <Typography variant="body2" mt={2} color="error" textAlign={"left"}>
              عدم ارتباط با سامانه مرکزی
              <Box component={"span"} sx={{ display: "block" }}>
                کاربر گرامی، در حال حاضر امکان برقراری ارتباط با سامانه مرکزی وجود ندارد. لطفاً ابتدا از اتصال صحیح
                دستگاه خود به اینترنت و خاموش بودن فیلترشکن اطمینان حاصل فرمایید. در صورتی که مشکل همچنان برطرف نشد،
                مراحل زیر را انجام دهید:
              </Box>
              <Box
                component="span"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  textAlign: "left",
                  mt: 1.5,
                }}
              >
                <span>۱. مرورگر Google Chrome را باز کنید.</span>
                <span>۲. از قسمت بالای سمت راست مرورگر، روی منوی سه‌نقطه کلیک کنید.</span>
                <span>۳. گزینه New Incognito Tab (پنجره ناشناس جدید) را انتخاب نمایید. </span>
                <span>۴. مجدداً وارد سامانه شوید.</span>
                <span>
                  چنانچه پس از انجام مراحل فوق همچنان با مشکل مواجه هستید، لطفاً با واحد پشتیبانی سامانه تماس حاصل
                  فرمایید
                </span>
              </Box>
            </Typography>
          </Stack>
        )
      )}
    </FormWrapperLogin>
  );
};

export default LoginPage;
